import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Chip from '@material-ui/core/Chip';

const SeatsCountFilter = ({ handleDeleteSeatsCount, onClick }) => {
  const { t } = useTranslation(['search']);
  const seatsCount = useSelector(state => state.search.seatsCount);

  if (seatsCount && seatsCount !== 'all') {
    return (
      <div style={{ display: 'inline' }}>
        <Chip
          key={`chip-gears-${seatsCount}`}
          label={t('seats') + t(`seats-count-${seatsCount}`)}
          onClick={onClick}
          onDelete={() => handleDeleteSeatsCount(seatsCount)}
          color="primary"
          variant="outlined"
        />
      </div>
    );
  } else {
    return null;
  }
};

export default SeatsCountFilter;
